import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { LineChart } from "@mui/x-charts/LineChart";
import PropTypes from "prop-types";
import { green, red } from "../../shared-theme/themePrimitives";

function AreaGradient({ color, id }) {
  return (
    <defs>
      <linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
        <stop offset="0%" stopColor={color} stopOpacity={0.5} />
        <stop offset="100%" stopColor={color} stopOpacity={0} />
      </linearGradient>
    </defs>
  );
}

AreaGradient.propTypes = {
  color: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

function getDaysInMonth(month, year) {
  const date = new Date(year, month, 0);
  const monthName = date.toLocaleDateString("en-US", {
    month: "short",
  });
  const daysInMonth = date.getDate();
  const days = [];
  let i = 1;
  while (days.length < daysInMonth) {
    days.push(`${monthName} ${i}`);
    i += 1;
  }
  return days;
}

export default function SessionsChart(props) {
  const theme = useTheme();
  // const data = getDaysInMonth(4, 2024);

  const colorPalette = [red["300"], green["500"], green["200"]];
  const data = props.data || {};
  const xAxisLabels = data.labels || [];

  const dataToShow = data.data || [];
  let total = 0;

  const yAxisData = dataToShow.map((item, index) => {
    total += item.value.reduce((acc, val) => acc + val, 0);
    return {
      id: item.label.toString().toLowerCase(),
      label: item.label,
      showMark: false,
      curve: "linear",
      stack: "total",
      area: true,
      stackOrder: "ascending",
      data: item.value || [],
    };
  });

  return (
    <>
      <Stack sx={{ justifyContent: "space-between" }}>
        <Stack
          direction="row"
          sx={{
            alignContent: { xs: "center", sm: "flex-start" },
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="h4" component="p">
            {total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Typography>
          <Chip
            size="small"
            color="error"
            label={`${data.changePercent > 0 ? "+" : ""} ${data.changePercent}%`}
          />
        </Stack>
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {props.title || ""}
        </Typography>
      </Stack>
      <LineChart
        colors={colorPalette}
        xAxis={[
          {
            scaleType: "point",
            data: xAxisLabels,
            tickInterval: (index, i) => (i + 1) % 5 === 0,
          },
        ]}
        series={yAxisData}
        height={250}
        margin={{ left: 50, right: 20, top: 20, bottom: 20 }}
        grid={{ horizontal: true }}
        sx={{
          "& .MuiAreaElement-series-open": {
            fill: "url('#open')",
          },
          "& .MuiAreaElement-series-closed": {
            fill: "url('#closed')",
          },
          "& .MuiAreaElement-series-resolved": {
            fill: "url('#resolved')",
          },
        }}
        slotProps={{
          legend: {
            hidden: true,
          },
        }}
      >
        {dataToShow.map((item, index) => (
          <AreaGradient
            key={item.label}
            color={colorPalette[index % colorPalette.length]}
            id={item.label.toLowerCase()}
          />
        ))}
      </LineChart>
    </>
  );
}
